/**
 * Strip all HTML tags from a string and collapse whitespace, returning plain
 * text suitable for one-line previews/snippets. Pure (regex-based) so it works
 * on the server too — unlike `cleanHtml`, which needs the DOM. Shared by the
 * job entity card and the Simple Search deck so previews strip consistently.
 */
export function stripHtml(value: string): string {
    return value.replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();
}

export function cleanHtml(html: string) {
    const allowedTags = [
        'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'P', 'UL', 'OL', 'LI', 'BR',
        'B', 'I', 'U', 'STRONG', 'EM',
        'DIV', 'SPAN', 'A', 'IMG'
    ];

    // Define allowed attributes for specific tags
    const allowedAttributes: Record<string, string[]> = {
        'A': ['href', 'target', 'rel', 'style'],
        'IMG': ['src', 'alt', 'title'],
        'DIV': ['class', 'id'],
        'SPAN': ['class', 'id']
    };

    // Parse the HTML using DOMParser
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    // Remove <style> and <script> tags
    doc.querySelectorAll('style, script').forEach(el => el.remove());

    // Traverse all elements
    doc.body.querySelectorAll('*').forEach(el => {
        if (!allowedTags.includes(el.tagName)) {
            // Replace unwanted tags with their text content
            const textNode = document.createTextNode(el.textContent || '');
            el.replaceWith(textNode);
        } else {
            // Remove attributes that aren't in the allowed list for this tag
            Array.from(el.attributes).forEach(attr => {
                const allowedAttrs = allowedAttributes[el.tagName] || [];
                if (!allowedAttrs.includes(attr.name)) {
                    el.removeAttribute(attr.name);
                }
            });

            // Add underline style to links
            if (el.tagName === 'A') {
                el.setAttribute('style', 'text-decoration: underline;');
            }
        }
    });

    // Serialize the cleaned DOM back to HTML
    return doc.body.innerHTML.trim();
}